import { CSSProperties } from 'react';
import styled from 'styled-components/macro';

export const AlertWrapper = styled.div<{
  margin?: string;
  $info?: boolean;
  $confirmInfo?: boolean;
  $error?: boolean;
  $backgroundColor?: string;
  $additionalStyle?: CSSProperties;
  $blackWindow?: boolean;
}>`
  min-height: 2.5rem;
  height: fit-content;
  display: flex;
  padding: ${({ theme }) => theme.spacing.zero_2};
  border-radius: ${({ theme }) => theme.spacing.zero_2};
  border: solid 1px;
  border-color: ${({ theme, $info, $confirmInfo, $error, $blackWindow }) =>
    $info
      ? theme.colors.primary
      : $confirmInfo
      ? theme.colors.positive_dark
      : $error
      ? theme.colors.negative_dark
      : $blackWindow
      ? theme.colors.black_100
      : theme.colors.warning_dark};
  margin-bottom: ${({ theme }) => theme.spacing.one_2};
  background-color: ${({ theme }) => theme.colors.white};
  ${({ theme, margin }) =>
    margin ? `margin: ${margin}` : `margin-bottom: ${theme.spacing.one_2}`};
  align-items: center;

  ${({ $backgroundColor }) => $backgroundColor && ` background-color: ${$backgroundColor}; `}

  ${({ $additionalStyle }) => $additionalStyle && { ...$additionalStyle }}
`;

export const AlertDescription = styled.div<{
  $fontSize?: string;
  $textColor?: string;
}>`
  margin-left: ${({ theme }) => theme.spacing.zero_2};
  font-size: ${({ theme, $fontSize }) => $fontSize || theme.fontSize.xs};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  color: ${({ theme, $textColor }) => $textColor || theme.colors.black_80};
  flex: 1;
`;
